import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useUserSettingsOfficesGroup, useUserSettingsOfficesGroupValidator } from "../../@hooks"
import { userSettingsOfficesGroupFormData } from "../../@signals"


export default function UserSettingOfficesGroupDrawerName() {
	const { handleChangeOfficesGroupFormData } = useUserSettingsOfficesGroup()
	const { nameError } = useUserSettingsOfficesGroupValidator()

    return <TextFieldSeeker
		label="Name"
		error={nameError}
		value={userSettingsOfficesGroupFormData.value?.name || []}
		onChange={e => handleChangeOfficesGroupFormData(e.target.value, 'name')}
	/>
}